import { GLOBAL_PARTNERS } from "@/lib/homepageStats";

// Renders just the number for "Trusted by N+ Global Partners" — used in 17
// marketing pages. GLOBAL_PARTNERS is a static value baked in at build time
// (see lib/homepageStats.ts) — no fetch, no client-side state. Kept as its
// own component (rather than inlining {GLOBAL_PARTNERS} in each of the 17
// files) purely so all 17 call sites don't need editing again if this ever
// needs to become dynamic again.
export default function GlobalPartnersCount() {
  return <>{GLOBAL_PARTNERS}</>;
}
